/**
 * Removes timezone information from a Date object without converting the time.
 * @param {Date | string} inputDate - The original date object or ISO date string.
 * @returns {Date} A new Date object with the same date and time, but treated as local time.
 */
export const removeTimezone = (inputDate: Date | string) => {
  // Remove 'Z' or timezone offset if present
  const inputString =
    inputDate instanceof Date ? inputDate.toISOString() : inputDate;
  const cleanInput = inputString.replace(/Z|([+-]\d{2}:\d{2})$/, "");

  // Split into date and time parts
  const [datePart, timePart = "00:00:00"] = cleanInput.split("T");
  const [year, month, day] = datePart.split("-").map(Number);

  // Handle time with optional milliseconds
  const [hour, minute, secondWithMs = "0"] = timePart.split(":");
  const [second, millisecond = "0"] = secondWithMs.split(".");

  return new Date(
    Number(year),
    Number(month) - 1,
    Number(day),
    Number(hour),
    Number(minute),
    Number(second),
    Number(millisecond),
  );
};
